import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './react-tabs.less';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import TabContent from './TabContent';

import './tabGroup.less';

class TabGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {emptyTabs : []};
    }
    setEmpty(tabId) {
        this.setState((prevState, currentProps) => {
            if(!prevState.emptyTabs.includes(tabId)) {
                return {...prevState, emptyTabs: prevState.emptyTabs.concat(tabId)};
            }
            else {
                return prevState;
            }
        });
    }
    shouldRenderTab(tabId) {
        return !this.state.emptyTabs.includes(tabId);
    }
    displayOptionalTitle() {
        if (this.props.title) {
            return <h1 className="tab-group-title">{this.props.title}</h1>
        }
    }
    /**
     *
     * @param {Array<TabContent>} children the component's props.children
     */
    renderTabLabels(children) {
        return React.Children.map(children, (tab, i) => {
            if(this.shouldRenderTab(i)) {
                return (<Tab>{tab.props.name}</Tab>);
            }
            else {
                return null;
            }
        });
    }
    /**
     *
     * @param {Array<TabContent>} children the component's props.children
     */
    renderTabContent(children) {
        return React.Children.map(children, (tab, i) => {
            if(this.shouldRenderTab(i)) {
                return (<TabPanel>{React.cloneElement(tab,{onNullRender: () => this.setEmpty(i)})}</TabPanel>);
            }
            else {
                return null;
            }
        });
    }
    render() {
        const children = this.props.children;
        if(this.state.emptyTabs.length < React.Children.count(children)) {
            return (
                <div className="tab-group">
                    {this.displayOptionalTitle()}
                    <Tabs forceRenderTabPanel={true}>
                        <TabList>
                            {this.renderTabLabels(children)}
                        </TabList>
                        {this.renderTabContent(children)}
                    </Tabs>
                </div>
            )
        }
        else {
            return null;
        }
    }
}

TabGroup.propTypes = {
    children: PropTypes.node,
};

export default TabGroup;



// WEBPACK FOOTER //
// ./src/react/containers/TabGroup.jsx